const Share = ({ color }: any) => {
  return (
    <svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M21 12.3008L14 5.30078V9.30078C7 10.3008 4 15.3008 3 20.3008C5.5 16.8008 9 15.2008 14 15.2008V19.3008L21 12.3008Z'
        stroke={color || '#65676B'}
        strokeWidth='2'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default Share
